import { MediaModel } from 'types/cms/components'

/**
 * Type guard to check and enforce public_id presence
 * @param metaData
 * @returns {metaData is MediaModel["provider_metadata"]}
 */
export const hasPublicId = (metaData: unknown): metaData is MediaModel['provider_metadata'] => {
  if (!metaData || typeof metaData !== 'object') {
    return false
  }

  return 'public_id' in metaData
}
